import { useTranslation } from "react-i18next";
import SectionHeading from "../components/SectionHeading";
import SectionSubheading from "../components/SectionSubheading";
import AboutUsDescription from "../components/AboutUsDescription";
import About1 from "../assets/About1.png";
import WeProvideBlock from "../components/WeProvideBlock";
import { useInternationalizedItems } from "../custom-hooks/useInternationalizedItems";
import { HeadingVariant } from "../types/constants";

export default function AboutSection() {
    const { t } = useTranslation();

    const aboutUsDescription = useInternationalizedItems<string[]>({
        key: "home.paragraphs.aboutUsDescription",
    });

    return (
        <section>
            <div className="flex flex-col lap:flex-row gap-8 md:gap-12 lap:gap-5 items-start">
                <div className="flex flex-col w-full lap:w-[458px] xl:w-[630px]">
                    <div className="mb-4 lg:mb-6">
                        <SectionHeading text={t("home.headings.aboutUs")} variant={HeadingVariant.DARK} />
                    </div>
                    <div className="mb-3">
                        <SectionSubheading text={t("home.subheadings.aboutUs")} />
                    </div>
                    <AboutUsDescription paragraphs={aboutUsDescription} />
                </div>

                <img
                    src={About1}
                    alt={t("home.aboutUs.alt")}
                    className="w-full lap:w-[458px] xl:w-[530px] lg:w-[630px] h-auto rounded-md object-cover"
                />
            </div>

            <div className="w-full max-w-[1280px] mx-auto mt-10">
                <h3 className="uppercase font-medium text-xl text-primary-400 text-left">
                    {t("home.headings.weProvide")}
                </h3>
                <WeProvideBlock />
            </div>
        </section>
    );
}
